'use strict';

module.exports = {
  market: 'market',
  clickAndCollect: 'clickAndCollect',
  segmentation: 'segmentation',
  teardown: 'teardown',
  shrink: 'shrink',
};
